export default __webpack_public_path__ + "static/media/and Bitmap@2x.4ca4fc03.png";